import { PRINT_STORE_CATEGORIES_LIST_QUERY } from '@dtx-company/flow-codegen/src/code/queries'
import {
  PrintStoreProductCategoriesListQuery,
  QueryPrintStoreProductCategoriesArgs
} from '@dtx-company/flow-codegen/src/code/generated.types'
import { getCategoriesListKey } from './CategoriesList.utils'
import { gqlFetcher } from '@dtx-company/inter-app/src/services/gqlFetcher'
import useSWRInfinite, { SWRInfiniteResponse } from 'swr/infinite'

export const useFetchCategoriesList = (
  variables: QueryPrintStoreProductCategoriesArgs = {},
  token?: string
): SWRInfiniteResponse<PrintStoreProductCategoriesListQuery> => {
  const data = useSWRInfinite(
    (
      pageIndex: number,
      previousPageData: PrintStoreProductCategoriesListQuery | null
    ): string[] | null => {
      return getCategoriesListKey(variables, pageIndex, previousPageData, token)
    },
    ([_, cursor, token]) =>
      gqlFetcher<PrintStoreProductCategoriesListQuery, QueryPrintStoreProductCategoriesArgs>(
        PRINT_STORE_CATEGORIES_LIST_QUERY,
        {
          after: cursor,
          ...variables
        },
        undefined,
        token
      ),
    {
      revalidateOnFocus: false
    }
  )
  return data
}
